import { __assign, __rest } from "tslib";
import * as React from 'react';
import { CnDemoDescription as UICnDemoDescription, CnDemoRect as UICnDemoRect, CnDemoBlock as UICnDemoBlock, } from '@cainiaofe/cn-ui-m/es/components/cn-demo';
import { CnPage } from '@cainiaofe/cn-ui';
export var CnDemoPage = function (props) {
    var title = props.title, restProps = __rest(props, ["title"]);
    return React.createElement(CnPage, __assign({}, restProps));
};
export var CnDemoBlock = function (props) {
    return React.createElement(UICnDemoBlock, __assign({}, props));
};
export var CnDemoDescription = function (props) {
    return React.createElement(UICnDemoDescription, __assign({}, props));
};
export var CnDemoRect = function (props) {
    return React.createElement(UICnDemoRect, __assign({}, props));
};
